import React from 'react';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { ReadPatternHook } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';
import { OrganizationSecretItems } from 'libs/end-to-end/src/types/secrets/organization-secret-items';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { DataSetSecretSelector } from 'apps/sigma2-ui/src/data-wizard/components/DataSetSecretSelector';
import { S2Checkbox } from 'apps/sigma2-ui/src/components/ui/Checkbox';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';

export const DataSetADPConfigurationComponent = ({
  organizationId,
  clientIdSecretReference,
  clientSecretSecretReference,
  setClientIdSecretReference,
  setClientSecretSecretReference,
  sslCertSecretReference,
  setSslCertSecretReference,
  keyCertSecretReference,
  setKeyCertSecretReference,
  listSecretsPattern,
  agentMode,
  setAgentMode,
  agentDateCap,
  setAgentDateCap,
}: {
  organizationId: string;
  clientIdSecretReference: SecretReference | null;
  clientSecretSecretReference: SecretReference | null;
  setClientIdSecretReference: Setter<SecretReference | null>;
  setClientSecretSecretReference: Setter<SecretReference | null>;
  sslCertSecretReference: SecretReference | null;
  setSslCertSecretReference: Setter<SecretReference | null>;
  keyCertSecretReference: SecretReference | null;
  setKeyCertSecretReference: Setter<SecretReference | null>;
  listSecretsPattern: ReadPatternHook<OrganizationSecretItems>;
  agentMode: boolean | null;
  setAgentMode: Setter<boolean>;
  agentDateCap: string;
  setAgentDateCap: Setter<string>;
}) => {
  return (
    <Spacing size={'md'} direction={'vertical'}>
      <DataSetSecretSelector
        label={'Client ID'}
        secretReference={clientIdSecretReference}
        setSecretReference={setClientIdSecretReference}
        organizationId={organizationId}
        listSecretsPattern={listSecretsPattern}
      />

      <DataSetSecretSelector
        label={'Client Secret'}
        secretReference={clientSecretSecretReference}
        setSecretReference={setClientSecretSecretReference}
        organizationId={organizationId}
        listSecretsPattern={listSecretsPattern}
      />

      <DataSetSecretSelector
        label={'SSL Certificate'}
        secretReference={sslCertSecretReference}
        setSecretReference={setSslCertSecretReference}
        organizationId={organizationId}
        listSecretsPattern={listSecretsPattern}
      />

      <DataSetSecretSelector
        label={'Key Certificate'}
        secretReference={keyCertSecretReference}
        setSecretReference={setKeyCertSecretReference}
        organizationId={organizationId}
        listSecretsPattern={listSecretsPattern}
      />

      <S2Checkbox
        checked={agentMode === true}
        onChange={() => {
          setAgentMode(!agentMode);
        }}
      >
        {'Enable Agent Mode'}
      </S2Checkbox>

      {agentMode && (
        <ADPAgentModeConfigurationComponent
          agentModeDateCap={agentDateCap}
          setAgentModeDateCap={setAgentDateCap}
        />
      )}
      
    </Spacing>
  );
};

export const ADPAgentModeConfigurationComponent = ({
  agentModeDateCap,
  setAgentModeDateCap,
}: {
  agentModeDateCap: string;
  setAgentModeDateCap: Setter<string>;
}) => {

  const dateCapOptions = [
    { label: 'Last 7 Days', value: '7' },
    { label: 'Last 30 Days', value: '30' },
    { label: 'Last 60 Days', value: '60' },
    { label: 'Last 90 Days', value: '90' },
    { label: 'All', value: 'all' },
  ];

  return (
    <Spacing size={'md'} direction={'vertical'}>
      <SelectBoxWithSearch
        type="single"
        list={dateCapOptions.map((option) => ({
          optionLabel: option.label,
          optionValue: option.value,
        }))}
        label={'Last # of Days'}
        selected={agentModeDateCap}
        setSelected={(value: string) => {
          if (dateCapOptions.some((option) => option.value === value)) {
            setAgentModeDateCap(value);
          }
        }}
      />
    </Spacing>
  );
};
